<h2 class="first_title"><span class="hidden-xs">Gestione Metadati Fascicolo</span></h2>
<ng-container *ngIf="ctxBodyFascicolo?.fascicolo">
  <ul pathbar 
      [fascicolo]="ctxBodyFascicolo.fascicolo"
      [pratica]="ctxBodyFascicolo.fascicolo.praticaBase">
  </ul>

  <div class="standardpanel">
    <ul intestazione_pratica
        [pratica]="ctxBodyFascicolo.fascicolo.praticaBase">
    </ul>
  </div>
  <div class="content-page-wrapper" *ngIf="metadatiFascicolo as fascicolo">
    <!-- METADATI -->
    <div class="standardpanel">
      <div class="titleblock">
        <h3 class="title1level">
          Metadati del fascicolo
        </h3>
      </div>

      <div class="container_dati_generali">
        <div class="row">
            <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
              [labelInput]="'ID Fascicolo'" [valueInput]="fascicolo.idFascicolo"></div>
            <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
              [labelInput]="'Posizione Fascicolo'" [valueInput]="fascicolo.posizioneFascicolo"></div>
        </div>
        <div class="row">
            <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
              [labelInput]="'Titolario'" [valueInput]="fascicolo.classeTitolario"></div>
        </div>
      </div>
    </div>

    <!-- DOCUMENTI -->
    <div class="standardpanel">
      <div class="titleblock">
        <h3 class="title1level">Elenco documenti fascicolo</h3>
      </div>

      <div class="container_dati_generali">
        <div *ngIf="documenti?.length > 0; else noDocumenti">
          <ul class="list-group mt-2">
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              *ngFor="let documento of documenti"
            >
            <span>
                <a
                  href="javascript:void(0)"
                  (click)="openDocumentoMetadata(documento)"
                  class="file-link"
                >
                  <span class="glyphicon glyphicon-file icon-space"></span>
                  {{ documento.nomeFile }}
                </a>
              </span>
            </li>
          </ul>

        </div>

        <ng-template #noDocumenti>
          <div class="alert alert-info mt-2">
            Nessun documento presente nel fascicolo.
          </div>
        </ng-template>

      </div>
    </div>

  </div>
</ng-container>